import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  base: {
    borderRadius: 'md',
    fontWeight: 'normal',
    px: 2,
    textTransform: 'none',
  },
  defaultVariants: {
    size: 'lg',
    variant: 'subtle',
    colorPalette: 'brandSecondary',
  },
  variants: {
    size: {
      sm: {
        borderRadius: 'lg',
      },
      lg: {},
    },
    variant: {
      subtle: {},
    },
  },
});
